import { Inject, Injectable } from '@angular/core';
import { USER } from 'src/app/core/user.service';
import { TcsConfig } from 'src/app/shared/tcs/tcs.config';
import { TCS_CONFIG } from 'src/app/shared/tcs/tcs.config.token';
import { UserViewModel } from 'src/view-models/user-view-model';

@Injectable()
export class TcsUrlService {
  private _baseUrl: string;

  constructor(@Inject(TCS_CONFIG) config: TcsConfig, @Inject(USER) private user: UserViewModel) {
    this._baseUrl = config.baseUri;
  }

  public manageUnitUrl(baseId?: string | null | undefined) {
    const url = `${this._baseUrl}/${this.user.companycode}/ops/units/manage`;
    return baseId != null ? `${url}?baseId=${baseId}` : url;
  }
}
